// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2025/6/5
// +-------------------------------------------------------------
// |Time: 15:25
// +-------------------------------------------------------------
export default [
    {
        path: '/activities/activity-list',
        name: "ActivityList",
        meta: {
            title: "活动列表"
        },
        component: () => import("@/views/Activities/Activity/Index.vue")
    },
    {
        path: '/activities/coupon-record',
        name: "CouponRecordList",
        meta: {
            title: "优惠券记录"
        },
        component: () => import("@/views/Activities/Coupon/Index.vue")
    },
]